export const CONFIG = {
  MAPBOX_TOKEN:
    'pk.eyJ1IjoiY2l0eXN0b3JhZ2VzeXN0ZW1zIiwiYSI6ImNsN2pqMmt5ZTAweXAzdm9rZDlwNzNmMGoifQ.Zj3AcvaM1fgUd8GvBBHvYQ',
  MAP_STYLE: 'mapbox://styles/citystoragesystems/clkbmoq48000001r22rz2ddy1',
  TOMTOM_TOKEN: 'xFHVMNiB4g7VLrKlQwycBfksC48JrFfr',
};
